import SampleAudioComponent from '@components/history/historyItem/body/tasks/values/sampleAudioComponent';
import SampleImageComponent from '@components/history/historyItem/body/tasks/values/sampleImageComponent';
import SampleMultiTextComponent from '@components/history/historyItem/body/tasks/values/sampleMultiTextComponent';
import { TaskType } from '@interfaces/task-type';
import AppContext from '@services/Context';
import { Col, Row } from 'antd';
import React from 'react';

import I18n from '../../../../../i18n';
import styled, { Theme } from '../../../../../styled-components';
import SampleTextComponent from './values/sampleTextComponent';

interface IProp {
    tasks: any
}

class TasksHolderComponent extends React.Component<IProp, {}> {

    renderTaskItem (task: any, i: number) {
        return (
            <GoEpikTaskHolder key={i} >
                <Row className="goepik-component-padding">
                    <Col sm={24} md={24} xl={24} className="goepik-span-number goepik-history-question-text">
                        <span>{i + 1}</span> {task.title}
                    </Col>
                    <Col sm={24} md={24} xl={24}>
                        {
                            this.renderTaskValue(task.type, task)
                        }
                    </Col>
                </Row>
            </GoEpikTaskHolder>
        )
    }

    renderTaskValue (type: TaskType, task: any) {
        switch (type) {
            case TaskType.PROBLEM:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleTextComponent text={task.value} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.AUDIO:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleAudioComponent actionText={(I18n.l('buttons.visualize.label')) + " " + (I18n.l('words.draw.label'))} url={task.value} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.DATE:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleTextComponent text={new Date(task.value).toLocaleDateString()} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.DRAW:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleImageComponent actionText={(I18n.l('common.visualize')) + " " + (I18n.l('common.draw'))} url={task.value} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.PHOTO:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleImageComponent actionText={(I18n.l('common.visualize')) + " " + (I18n.l('common.image'))} url={task.value} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.SELECT:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleMultiTextComponent texts={task.value} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.CONFIRM:
                if (task.value) {
                    return (
                        <AppContext.Consumer>
                            {({ locale, theme }) => (
                                <SampleTextComponent text={I18n.l('common.yes')} />
                            )}
                        </AppContext.Consumer>
                    )
                } else {
                    return (
                        <AppContext.Consumer>
                            {({ locale, theme }) => (
                                <SampleTextComponent text={I18n.l('common.no')} />
                            )}
                        </AppContext.Consumer>
                    )
                }

            case TaskType.NUMBER:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleTextComponent text={task.value.toString()} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.SCORE:
                if (task.value === null || task.value === undefined) {
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <p>{I18n.l('history.timeline.cantShowContent.label')}</p>
                        )}
                    </AppContext.Consumer>
                } else {
                    return (
                        <AppContext.Consumer>
                            {({ locale, theme }) => (
                                <GoEpikScore>
                                    {task.resultValue != undefined
                                        ?
                                        task.resultValue.toString()
                                        :
                                        <div>
                                            <span>
                                                {I18n.l('labels.scoreLabel')}
                                            </span>
                                            <span>{task.value.toString()}</span>
                                        </div>
                                    }

                                </GoEpikScore>
                            )}
                        </AppContext.Consumer>
                    )
                }

            case TaskType.TEXT:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleTextComponent text={task.value} />
                        )}
                    </AppContext.Consumer>
                )

            case TaskType.MATRIX:

                let content: string[] = [];
                if (task.value.labelX && task.value.valueX) content.push((task.value.labelX + ": " + task.value.valueX));
                if (task.value.labelY && task.value.valueY) content.push((task.value.labelY + ": " + task.value.valueY));
                if (task.value.result) content.push(("Risco: " + task.value.result));

                return (
                    <SampleMultiTextComponent texts={content} />
                )

            default:
                return (
                    <AppContext.Consumer>
                        {({ locale, theme }) => (
                            <SampleTextComponent text={I18n.l('history.timeline.cantShowContent.label')} />
                        )}
                    </AppContext.Consumer>
                )
        }
    }



    render (): JSX.Element {
        return (
            <Row>
                <Col sm={24} md={24} xl={24}>
                    {
                        this.props.tasks.map((task: any, i: number) => {
                            return (
                                this.renderTaskItem(task, i)
                            )
                        })
                    }
                </Col>
            </Row>
        );
    }
};

const GoEpikTaskHolder = styled.div`
    .goepik-span-number{

        span {
            margin-right: 0.5em;
            color: ${Theme.primary.light};
            font-weight: bold;
        }
    }

    .goepik-history-question-text{
        font-weight:500;
    }
`;

const GoEpikScore = styled.div`
    color: ${Theme.standard.orange};
    font-weight: bold;
    font-size: x-large;    

    span {
        margin-right: 0.5em;
    }
`;

export default TasksHolderComponent;
